import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class BaseAPIClient {
  constructor(request) {
    _defineProperty(this, "request", void 0);
    this.request = request;
  }
}
//# sourceMappingURL=BaseAPIClient.js.map